/**
 * Logo Component
 *
 * Displays logo with scroll-based animation (text/image transition)
 */

import React from "react";
import { Link } from "react-router-dom";
import NavigationStylesExport from "../NavigationStyles";

const Logo = ({ scrollProgress = 0, logoUrl }) => {
  const { HEADER_STYLES } = NavigationStylesExport;

  // Calculate text opacity (bidirectional - fades out on scroll down, fades in on scroll up)
  const getTextOpacity = () => {
    const textFadeStart = 0.2; // Start fading text at 20% (earlier for smoother transition)
    const textFadeEnd = 0.6; // Text fully faded at 60%

    if (scrollProgress < textFadeStart) return 1;
    if (scrollProgress > textFadeEnd) return 0;

    const fadeProgress =
      (scrollProgress - textFadeStart) / (textFadeEnd - textFadeStart);
    return Math.max(0, Math.min(1, 1 - fadeProgress)); // Ensure opacity stays within 0-1 range
  };

  // Calculate logo image opacity (bidirectional - fades in on scroll down, fades out on scroll up)
  const getLogoOpacity = () => {
    const imageFadeStart = 0.4; // Start showing logo at 40% (overlaps with text for crossfade)
    const imageFadeEnd = 0.8; // Fully visible at 80%

    if (scrollProgress < imageFadeStart) return 0;
    if (scrollProgress > imageFadeEnd) return 1;

    const fadeProgress =
      (scrollProgress - imageFadeStart) / (imageFadeEnd - imageFadeStart);
    return Math.max(0, Math.min(1, fadeProgress)); // Ensure opacity stays within 0-1 range
  };

  const textOpacity = getTextOpacity();
  const logoOpacity = getLogoOpacity();

  return (
    <div className={HEADER_STYLES.logoWrapper}>
      <Link to="/" className={HEADER_STYLES.logoContainer}>
        {" "}
        {/* Fixed minimum width to prevent layout shift */}
        {/* Company Name Text - Fades in when scrolling up, fades out when scrolling down */}
        <h1
          className={HEADER_STYLES.logoText}
          style={{
            opacity: textOpacity,
            fontFamily:
              '"Inter", "Segoe UI", "Roboto", "Helvetica Neue", sans-serif',
          }}
        >
          TadReamk
        </h1>
        {/* Company Logo Image - Fades out when scrolling up, fades in when scrolling down */}
        <img
          src={logoUrl}
          alt="TadReamk Logo"
          className={HEADER_STYLES.logoImage}
          style={{
            opacity: logoOpacity,
            transform: `scale(${0.95 + logoOpacity * 0.05})`, // Subtle scale from 0.95 to 1.0
          }}
        />
      </Link>
    </div>
  );
};

export default Logo;
